(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/scroll-to-top';
import '../assets/styles/components/Residents.scss';
import ImageWebp from '../components/custom/ImageWebp';
import imgResidents from '../assets/static/tops/residents.png';
import SchemaResidentsFAQS from '../components/Schemas/SchemaResidentsFAQS';
const tenantsFaqs = [{
  question: 'Will I get my security deposit back?',
  answer: 'The return of your security deposit is pending the move-out inspection.'
}, {
  question: 'Can I use my security deposit for my last month of rent?',
  answer: 'No, California law prohibits this.'
}, {
  question: 'What happens if I need to break my lease?',
  answer: 'Under this type of contract, you are agreeing to occupy the housing unit for a fixed amount of time. You are responsible for all rent payments through the lease term, even if you move out before the lease expires. If you move out prior to lease end, you are responsible for the rent or for finding a suitable replacement that must be pre-approved by Management.'
}, {
  question: 'What happens if my roommate wants to go, but I want to stay?',
  answer: 'Subleasing is not allowed. Please work with Management to get approval to have someone added to or taken off the lease.'
}, {
  question: 'I lost my keys, what should I do?',
  answer: 'Call Management at (800) 604-3430.'
}, {
  question: "When is my first month's rent due?",
  answer: 'First month’s rent is due before you move in.'
}, {
  question: 'Where can I pay the rent?',
  answer: 'Rent must be received on or before the first of every month. Tenants may pay rent online. You can pay rent online 24 hours a day, 7 days a week. <a href="https://cbmanagement.appfolio.com/connect/users/sign_in" target="_blank">Register your rent online here</a>. Rent may also be mailed to: Community Builders Management - 424 N. Lake Avenue, Suite 200, Pasadena, CA 91101.'
}, {
  question: 'I am having trouble registering on the Residence Service Portal. Where can I find help?',
  answer: 'Call Management at (800) 604-3430.'
}, {
  question: 'Are pets allowed?',
  answer: 'Yes, small pets (under 25 pounds) are allowed with a pet deposit and approval from Management.'
}, {
  question: 'Is smoking allowed on the property?',
  answer: 'No. All of our properties are smoke-free as is required by the City of Los Angeles.'
}, {
  question: 'Is the apartment furnished? ',
  answer: ' Furnished units are available for an additional charge upon request.'
}, {
  question: 'Can we use DISH instead of cable?',
  answer: 'No. DISH services are not allowed at any of our properties.'
}];
const parentsFaqs = [{
  question: 'How does my child apply for an apartment?',
  answer: 'Applications can be found here. If your child is a full-time student, you will need to complete a guarantor application found here.'
}, {
  question: 'Who is responsible for paying the rent?',
  answer: 'All parties listed on the lease, including the guarantors, are responsible for rent throughout the term of the lease.'
}, {
  question: 'Can we complete the lease online?',
  answer: 'Yes.'
}, {
  question: 'What documents do we need to provide to complete a lease agreement?',
  answer: 'You need to provide the following: government issued ID (driver license or state identification), proof of income (two most recent pay stubs) or parental guarantee form, proof of school enrollment (when applicable), credit screening, and $35 application fee per person and per guarantor.'
}, {
  question: 'What does a security deposit cover?',
  answer: 'It may cover many things, but it is generally used to pay for damage above and beyond normal wear and tear.'
}, {
  question: 'When is the first payment due?',
  answer: 'Rent is due the first of every month. To secure your lease, you must pay the security deposit and first month’s rent.'
}, {
  question: 'Are there laundry facilities?',
  answer: 'All properties have washers and dryers located on-site. Some units offer a washer and dryer in the apartment.'
}, {
  question: 'Are pets allowed?',
  answer: 'Yes, small pets (under 25 pounds) are allowed with a pet deposit and approval from Management.'
}, {
  question: 'Is there security?',
  answer: 'Yes. All our properties are located within the Department of Public Safety (DPS) zone. This means that USC Security provides additional cruiser and foot patrols and has community liaisons stationed throughout the zone.'
}, {
  question: 'Is the apartment furnished? ',
  answer: ' Furnished units are available for an additional charge upon request.'
}, {
  question: 'How do I pay the rent?',
  answer: "Rent must be received on or before the first of every month. Tenants may pay rent online. You can <a href='https://cbmanagement.appfolio.com/connect/users/sign_in' target='_blank' rel='noreferrer noreferrer'>pay rent online<span class='sr-only'> (opens in new tab)</span></a> 24 hours a day, 7 days a week. Click here to register. Rent may also be mailed to: Community Builders Management - 424 N. Lake Avenue, Suite 200, Pasadena, CA 91101."
}];
const classBtns = 'btn btn-outline-main';
class Residents extends React.Component {
  constructor(props) {
    super(props);
    this.handleTabs = e => {
      this.setState({
        activeTab: e.target.dataset.target
      });
    };
    this.state = {
      activeTab: 'tenants'
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Housing Information for USC Students and Parents"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "Here you will find valuable housing Information for USC Students and Parents, with the most frequently asked questions we receive."
    }), /*#__PURE__*/React.createElement(SchemaResidentsFAQS, null)), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("main", {
      id: "content",
      className: "bypass-block-target main-content container padding-top-inner padding-bottom-inner",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement("header", {
      className: "intro-grid"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 intro-grid__heading"
    }, /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "COMMUNICATION"), " ", /*#__PURE__*/React.createElement("br", null), "IS EVERYTHING"), /*#__PURE__*/React.createElement(ImageWebp, {
      src: imgResidents,
      alt: "LiveCBM about us",
      className: "img-fluid",
      classNamePictureTag: "intro-grid__image",
      width: "657",
      height: "492"
    }), /*#__PURE__*/React.createElement("p", {
      className: "intro-grid__paragraph"
    }, "We are available to answer your questions."), /*#__PURE__*/React.createElement(Link, {
      to: "/contact-us",
      className: "btn btn-outline-main intro-grid__btn"
    }, "CONTACT US")), /*#__PURE__*/React.createElement("div", {
      className: "nav-btns btns-faq",
      role: "tablist"
    }, /*#__PURE__*/React.createElement("button", {
      className: this.state.activeTab === 'tenants' ? `${classBtns} active` : classBtns,
      "data-target": "tenants",
      onClick: this.handleTabs,
      id: "tenants-tab",
      type: "button",
      role: "tab",
      "aria-controls": "tenants",
      "aria-selected": "true"
    }, "FAQs TENANTS"), /*#__PURE__*/React.createElement("button", {
      className: this.state.activeTab === 'parents' ? `${classBtns} active` : classBtns,
      "data-target": "parents",
      onClick: this.handleTabs,
      id: "parents-tab",
      type: "button",
      role: "tab",
      "aria-controls": "parents",
      "aria-selected": "true"
    }, "FAQs PARENTS")), /*#__PURE__*/React.createElement("div", {
      className: this.state.activeTab === 'tenants' ? 'tab-pane--opened' : 'tab-pane',
      id: "tenants",
      role: "tabpanel",
      "aria-labelledby": "tenants-tab"
    }, tenantsFaqs.map((faq, i) => /*#__PURE__*/React.createElement(ItemFaq, {
      key: i,
      question: faq.question,
      answer: faq.answer
    }))), /*#__PURE__*/React.createElement("div", {
      className: this.state.activeTab === 'parents' ? 'tab-pane--opened' : 'tab-pane',
      id: "parents",
      role: "tabpanel",
      "aria-labelledby": "parents-tab"
    }, parentsFaqs.map((faq, i) => /*#__PURE__*/React.createElement(ItemFaq, {
      key: i,
      question: faq.question,
      answer: faq.answer
    })))), /*#__PURE__*/React.createElement(Footer, null));
  }
  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }
}
const ItemFaq = ({
  question,
  answer
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "item-faq"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h5 item-faq__question"
  }, "Q: ", question), /*#__PURE__*/React.createElement("p", {
    className: "item-faq__answer",
    dangerouslySetInnerHTML: {
      __html: answer
    }
  }));
};
const _default = Residents;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(tenantsFaqs, "tenantsFaqs", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
  reactHotLoader.register(parentsFaqs, "parentsFaqs", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
  reactHotLoader.register(classBtns, "classBtns", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
  reactHotLoader.register(Residents, "Residents", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
  reactHotLoader.register(ItemFaq, "ItemFaq", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/pages/Residents.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();